import { render, staticRenderFns } from "./ScheduleOnboarding.vue?vue&type=template&id=252787e2&"
import script from "./ScheduleOnboarding.vue?vue&type=script&lang=js&"
export * from "./ScheduleOnboarding.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports